// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"29b95fe1","977":"f8f74e60"}[chunkId] + ".chunk.js";
};